'use client';
import Titles, { TitleProps } from '../common/Titles';
import { ImageListItem, Stack } from '@mui/material';
import useIsMobile from '../../../../utils/useIsMobile';

type Props = TitleProps & {
  isLarge?: boolean;
  variant?: 'standard' | 'simple';
};

const TitleItem = ({ variant, isLarge, ...props }: Props) => {
  const isMobile = useIsMobile();
  if (!variant) return null;
  return (
    <ImageListItem cols={isLarge ? 2 : 1} rows={1}>
      <Stack
        sx={{
          p: 2,
          bgcolor: 'background.paper',
          borderRadius: 0.5,
          height: '100%',
          width: '100%',
          justifyContent: 'end',
        }}
      >
        <Titles
          {...props}
          subtitle={
            variant !== 'simple' && !isMobile ? props.subtitle : undefined
          }
        />
      </Stack>
    </ImageListItem>
  );
};

export default TitleItem;
